import React from 'react';
import Icon from './grip.svg?react';
import SelectedIcon from './gripSelected.svg?react';

export const GripIcon = () => {
  return <Icon />;
};

export const SelectedGripIcon = () => {
  return <SelectedIcon />;
};
